export const urlGetHistory = "/wmsAsset/asset/histori-asset";

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "nama_asset",
    disablePadding: false,
    label: "NAMA FIXED ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang_sumber",
    disablePadding: false,
    label: "GUDANG SUMBER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang_tujuan",
    disablePadding: false,
    label: "GUDANG TUJUAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];





